"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCourseFeed;
var _getFeed = _interopRequireWildcard(require("./getFeed"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @typedef  {Object} CourseFeedItem
 * @property {string} id      The id of the course.
 * @property {string} title   The title of the course.
 * @property {string} link    A link to the page of the course on yoast.com.
 * @property {string} content Short information on the course, will be HTML encoded.
 * @property {string} image   A link the the header image for the course.
 * @property {string} shopUrl A link, placing the course in the user's cart on yoast.com.
 * @property {string} banner  ( Optional ) Text for the banner over the card.
 */

/**
 * Returns a single course feed item from a snapshot.
 *
 * @param {Document}        parsed     A parsed XML document.
 * @param {Node}            snapshot   A snapshot returned from the snapshotItem method of a XPathResult.
 * @param {XPathNSResolver} nsResolver A namespace resolver for the parsed document.
 *
 * @returns {CourseFeedItem} The CourseFeedItem representing the provided snapshot.
 */
function parseCourseFeedItem(parsed, snapshot, nsResolver) {
  const item = {};
  item.id = (0, _getFeed.getXPathText)("child::content:slug", parsed, snapshot, nsResolver);
  item.title = (0, _getFeed.getXPathText)("child::title", parsed, snapshot);
  item.link = (0, _getFeed.getXPathText)("child::link", parsed, snapshot);
  item.content = (0, _getFeed.getXPathText)("child::content:encoded", parsed, snapshot, nsResolver);
  item.image = (0, _getFeed.getXPathText)("child::content:image", parsed, snapshot, nsResolver);
  item.ctaButtonCopy = (0, _getFeed.getXPathText)("child::content:cta_button_copy", parsed, snapshot, nsResolver);
  item.ctaButtonType = (0, _getFeed.getXPathText)("child::content:cta_button_type", parsed, snapshot, nsResolver);
  item.ctaButtonUrl = (0, _getFeed.getXPathText)("child::content:cta_button_url", parsed, snapshot, nsResolver);
  item.readMoreLinkText = (0, _getFeed.getXPathText)("child::content:read_more_link_text", parsed, snapshot, nsResolver);
  item.isFree = (0, _getFeed.getXPathText)("child::content:is_free", parsed, snapshot, nsResolver);
  item.isBundle = (0, _getFeed.getXPathText)("child::content:is_bundle", parsed, snapshot, nsResolver);
  return item;
}

/**
 * Grabs the RSS feed from the requested URL and parses the items required for the course overview.
 *
 * @param {string}   url           The feed location.
 * @param {int}      maxItems      The amount of items you wish returned, 0 for all items.
 *
 * @returns {Promise.<Feed>} The retrieved feed.
 */
function getCourseFeed(url, maxItems) {
  return (0, _getFeed.default)(url, maxItems, parseCourseFeedItem);
}